<template lang="pug">
.ok-cancel-modal
  b-modal(v-model="_value" size="md" @ok="ok" no-close-on-backdrop no-close-on-esc)
    .register-body
      FormLabel(key-name="テンプレート名" :value="_templateName")
      FormLabel(key-name="文書種類" :value="_templateCategoryName")
      FormLabel(key-name="タイトル" :value="_templateTitle")
      FormLabel(key-name="本文" :value="_templateText")
      FormLabel(key-name="確認しましたボタン" :value="_needConfirmLabel")
      FormLabel(key-name="同意しましたボタン" :value="_needAgreementLabel")

    template(#modal-footer="{ ok }")
      b-button.btn.modal-ok-btn(@click="ok") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { SendDocumentTemplateTableItem } from "@/pc/containers/sendDocuments/SendDocumentTemplateTable.vue";

import FormLabel from "@/pc/components/forms/FormLabel.vue";

/**
 * ### メッセージ送信テンプレート詳細モーダル
 */
@Component({
  components: {
    FormLabel
  }
})
export default class SendDocumentTemplateDetailModal extends Vue {
  /** モーダル表示可否 */
  @Prop()
  value!: boolean;
  /** テンプレート */
  @Prop()
  template!: SendDocumentTemplateTableItem;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _templateName(): string {
    if (!this.template) {
      return "";
    }
    return this.template.name;
  }

  get _templateCategoryName(): string {
    if (!this.template) {
      return "";
    }
    return this.template.categoryName;
  }

  get _templateTitle(): string {
    if (!this.template) {
      return "";
    }
    return this.template.title ? this.template.title : "";
  }

  get _templateText(): string {
    if (!this.template) {
      return "";
    }
    return this.template.text ? this.template.text : "";
  }

  get _needConfirmLabel(): string {
    if (!this.template) {
      return "";
    }
    if (this.template.needConfirm == true) {
      return "つける";
    } else {
      return "つけない";
    }
  }

  get _needAgreementLabel(): string {
    if (!this.template) {
      return "";
    }
    if (this.template.needAgreement == true) {
      return "つける";
    } else {
      return "つけない";
    }
  }

  public ok(): void {
    this.$emit("ok");
    return;
  }
}
</script>
